import * as _ from 'lodash';
import * as utility from '../misc/utility';
import * as EnumValues from '../misc/EnumValues';
import { BaseObject } from './BaseObject';

export class SystemSettings extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);
        }
    }

    toJSON() {
        var ret = super.toJSON();
        ret.Address = utility.addressToJson(ret.Address, EnumValues.AddressType.Home);
        return ret;
    }
}
